module.exports = __webpack_public_path__ + "b037216ee2f79248a081d3ccf7e8f0cc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/ball-volleyball.png
// module id = 2976
// module chunks = 0